import type { CSSProperties } from 'react'

import type { SpeCreatorReturn } from './SpeCreator'

const disableOnSpeRequest = (
  spe: Partial<SpeCreatorReturn<unknown>>,
  { opacity = 0.8 } = {},
): CSSProperties =>
  spe.status === 'request' ? { opacity, cursor: 'not-allowed', pointerEvents: 'none' } : {}

export default disableOnSpeRequest
